import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles({
      container: {
        borderRadius: '4px'
      },
      subtitle: {},
      emailField: {
        '& .MuiInput-underline:before': {
          borderBottom: 'none'
        },
        '& .MuiInput-underline:after': {
          borderBottom: 'none'
        }
      },
      subscribeBtn: {
        height: '50px',
        '& p': {
          color: theme.palette.primary.contrastText,
          marginLeft: '10px'
        }
      }
    }),
  { name: 'BlogSubscribe' }
)
